module.exports = __webpack_public_path__ + "static/media/img36.baa2df4d.jpg";